import React from 'react';
import propTypes from 'prop-types';

// rfc = react functional components
// export default function Header(props) {
export default function Header(props) {
	return (
		<nav className="navbar navbar-expand-lg navbar-light bg-light">
			<div className="container-fluid">
				{/* <a className="navbar-brand" href="#">{props.title}</a> */}
				<a className="navbar-brand" href="#"><b>{props.title}</b></a>
				<button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
					<span className="navbar-toggler-icon"></span>
				</button>
				<div className="collapse navbar-collapse" id="navbarSupportedContent">
					<ul className="navbar-nav me-auto mb-2 mb-lg-0">
						<li className="nav-item">
							<a className="nav-link active" aria-current="page" href="#">Home</a>
						</li>
						<li className="nav-item">
							<a className="nav-link active" href="#">About</a>
						</li>
					</ul>
					{
						props.searchBar ?
							<form className="d-flex">
								<input className="form-control me-2" type="search" placeholder="Search" aria-label="Search" />
								<button className="btn btn-outline-success" type="submit">Search</button>
							</form>
							: ""
					}
				</div>
			</div>
		</nav>
	)
}

Header.defaultProps = {
	title: "Your title here",
	searchBar:true
}

Header.propTypes = {
	title: propTypes.string,
	searchBar: propTypes.bool.isRequired
}